import {
  FETCH_TEMPLATE_CONTENT_FULFILLED,
  FETCH_TEMPLATE_CONTENT_REJECTED,
  GetTemplateContentActionResponse,
} from "../actions/getTemplateContent";

export default function (
  state: { [k: string]: any } = {},
  action: GetTemplateContentActionResponse
) {
  switch (action.type) {
    case FETCH_TEMPLATE_CONTENT_FULFILLED: {
      if (action.meta.contentId) {
        return {
          ...state,
          [action.meta.templateName]: {
            ...state[action.meta.templateName],
            [action.meta.contentId]: (state[action.meta.templateName] && {
              ...state[action.meta.templateName][action.meta.contentId],
              [action.meta.languageCode]: action.payload.data,
            }) || {
              [action.meta.languageCode]: action.payload.data,
            },
          },
        };
      } else {
        const templateData = {};
        const filterByLang = (data: any, lang: any) => {
          const returnData = {};
          Object.keys(data).forEach((k) => {
            // @ts-ignore
            if (!returnData[k] && data.hasOwnProperty(k + "_" + lang)) {
              // @ts-ignore
              returnData[k] = data[k + "_" + lang];
            } else {
              // @ts-ignore
              returnData[k] = data[k];
            }
          });
          return returnData;
        };
        action.payload.data.forEach((data: any) => {
          // @ts-ignore
          templateData[data.contentId] = {
            [action.meta.languageCode]: filterByLang(
              data,
              action.meta.languageCode
            ),
          };
        });
        return {
          ...state,
          [action.meta.templateName]: {},
        };
      }
    }
    case FETCH_TEMPLATE_CONTENT_REJECTED: {
      if (action.meta.contentId) {
        const newState = { ...state };
        if (!newState[action.meta.templateName]) {
          newState[action.meta.templateName] = {};
        }
        newState[action.meta.templateName][action.meta.contentId] = {
          [action.meta.languageCode]: "",
        };
        return newState;
      }
      return state;
    }
    default:
      return state;
  }
}
